import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { FormikHelpers, FormikValues } from 'formik';
import { DateTime } from 'luxon';
import * as Yup from 'yup';

import { ReservationModel } from '../../services/models';
import { TypeTransport } from '../../utils/functions/mockTransport';
import { StepperProvider } from '../../contexts/stepper';
import formatDate from '../../utils/formatters/formatDate';
import handleCantReserve from '../../utils/functions/handleCantReserve';
import snackbarUtils from '../../utils/snackbarUtils';
import { formatError } from '../../utils/formatters';
import { PlaceService, ReservationService } from '../../services';

import Head from '../../components/Head';
import WhenYouCome from './WhenYouCome';
import WorkLocation from './WorkLocation';
import Transport from './Transport';
import Summary from './Summary';
import Layout from '../../layout';
import AppointmentOk from './AppointmentOk';
import { FormikStepper, FormikStep } from './FormikStepper';

export interface ValuesModel {
  date: DateTime,
  building: string,
  floor: string,
  section: string,
  desk: string,
  transport: TypeTransport,
  needParking: boolean;
};

const Values: ValuesModel = {
  date: DateTime.local().plus({ day: 1 }),
  building: '',
  floor: '',
  section: '',
  desk: '',
  transport: null,
  needParking: false,
}

const dateSchema = Yup.object().shape({
  date: Yup.date().required().default(() => {
    return new Date();
  })
});

const workPlaceSchema = Yup.object().shape({
  building: Yup.number().required('Este campo é obrigatório'),
  floor: Yup.string().required('Este campo é obrigatório'),
  section: Yup.string().required('Este campo é obrigatório'),
  desk: Yup.string().required('Este campo é obrigatório'),
});

const transportSchema = Yup.object().shape({
  transport: Yup.string().typeError('Selecione um tipo de transporte').required('Selecione um tipo de transporte'),
});

const NewAppointment = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    const fetchCanReserve = async () => {
      setLoading(true);
      try {
        const { data } = await ReservationService.canReserve();
        if (!data.can) {
          handleCantReserve(data.reason);
          history.replace('/agendamentos');
        }
        else return;
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false);
      }
    }
    fetchCanReserve();
  }, [history]);

  const handleFormik = async (values: FormikValues, formikHelpers: FormikHelpers<FormikValues>) => {
    try {
      // console.log(values);
      formikHelpers.setSubmitting(true);
      const formattedDate = formatDate(values.date.toString());
      const { data: places } = await PlaceService.availablePlaces(formattedDate);
      const filteredPlace = places.find((place => place.buildingId === Number(values.building)
        && place.floor === Number(values.floor)
        && place.sectionId === Number(values.section)
        && place.desk === values.desk
      ))
      // console.log(filteredPlace);
      if (!!filteredPlace) {
        const reservationData: ReservationModel = {
          date: formattedDate,
          parking: false,//values.needParking,
          placeId: filteredPlace.id,
          transportType: values.transport
        }
        const { data } = await ReservationService.create(reservationData);
        setCompleted(true);
        history.replace(`/novo-agendamento?reservationId=${data.id}`);
      }
      // formikHelpers.resetForm({ values: Values });
      // setHasSuccess(true)
    } catch (error) {
      console.error(error.message);
      snackbarUtils.error(formatError(error));
    }
    formikHelpers.setSubmitting(false);
  };

  return (
    <Layout
      page="newSchedule"
      backLink="/agendamentos"
      loading={loading}
      hideBackButton
      innerPage
    >
      <Head>Novo agendamento</Head>
      {!completed ? (
        <StepperProvider>
          <FormikStepper initialValues={Values} onSubmit={handleFormik}>
            <FormikStep label=" " validationSchema={dateSchema} >
              <WhenYouCome />
            </FormikStep>

            <FormikStep label=" " validationSchema={workPlaceSchema}>
              <WorkLocation />
            </FormikStep>

            <FormikStep label="" validationSchema={transportSchema}>
              <Transport />
            </FormikStep>

            <FormikStep label="">
              <Summary />
            </FormikStep>
          </FormikStepper>
        </StepperProvider>
      ) : (
        <AppointmentOk />
      )}

    </Layout>
  );
}

export default NewAppointment;
